var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-gray-100 rounded-md tw-p-3 text-sm line-height-tight" },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex tw-gap-2 tw-mb-2 align-items-center font-semibold text-md",
        },
        [
          _c("div", {
            staticClass: "size-6 do-svg-full",
            attrs: { title: "" },
            domProps: { innerHTML: _vm._s(_vm.accessoryInfo.logo) },
          }),
          _vm._v(" "),
          _c("span", [_vm._v(" " + _vm._s(_vm.accessoryInfo.label))]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "form-row row light tw-mb-1" }, [
        _c("label", { staticClass: "col-4" }, [
          _vm._v(_vm._s(_vm.$t("device.lastCommunication"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-label col" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.formatTime(_vm.device.dh_last_detection)) +
              "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row row light tw-mb-1" }, [
        _c("label", { staticClass: "col-4" }, [
          _vm._v(_vm._s(_vm.$t("device.idButton"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-label col text-mono" }, [
          _vm._v("\n      " + _vm._s(_vm.device.mac) + "\n    "),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-row row light d-flex align-items-center tw-mb-0" },
        [
          _c("label", { staticClass: "col-4" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("device.batteryLvl")))]),
          ]),
          _vm._v(" "),
          _c("Battery", {
            staticClass: "bracelet-battery m-0",
            attrs: { level: _vm.device.current_battery_level },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "col line-height-tight ml-1" }, [
            _c("span", { staticClass: "text-mono" }, [
              _vm._v(_vm._s(_vm.device.current_battery_level) + "%"),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.device.firmware_version
        ? _c("div", { staticClass: "form-row row light tw-mb-1" }, [
            _c("label", { staticClass: "col-4" }, [
              _vm._v(_vm._s(_vm.$t("device.firmware_version"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-label col text-mono" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.device.firmware_version) + "\n    "
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(_vm.accessoryInfo.subComponents, {
        tag: "component",
        attrs: { accesory: _vm.device },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }